export const iManagePopUp = (authUrl: string) => {

window.open(authUrl,  
    'popupWindow',
    'toolbar=no,menubar=no,scrollbars=yes,resizable=yes,top=100,left=100,width=600,height=600');
  };